function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "X Close 2"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 119",
  cx: 17,
  cy: 17.5,
  r: 16,
  fill: "#EBF3FD"
}), /*#__PURE__*/React.createElement("g", {
  id: "24. Close"
}, /*#__PURE__*/React.createElement("path", {
  id: "X",
  d: "M23.3749 12.5411C23.7654 12.1506 23.7654 11.5174 23.3749 11.1269C22.9844 10.7364 22.3512 10.7364 21.9607 11.1269L23.3749 12.5411ZM10.6274 22.4602C10.2368 22.8507 10.2368 23.4839 10.6274 23.8744C11.0179 24.2649 11.6511 24.2649 12.0416 23.8744L10.6274 22.4602ZM12.0416 11.1269C11.6511 10.7364 11.0179 10.7364 10.6274 11.1269C10.2368 11.5174 10.2368 12.1506 10.6274 12.5411L12.0416 11.1269ZM21.9607 23.8744C22.3512 24.2649 22.9844 24.2649 23.3749 23.8744C23.7654 23.4839 23.7654 22.8507 23.3749 22.4602L21.9607 23.8744ZM21.9607 11.1269L16.294 16.7935L17.7082 18.2078L23.3749 12.5411L21.9607 11.1269ZM16.294 16.7935L10.6274 22.4602L12.0416 23.8744L17.7082 18.2078L16.294 16.7935ZM10.6274 12.5411L16.294 18.2078L17.7082 16.7935L12.0416 11.1269L10.6274 12.5411ZM16.294 18.2078L21.9607 23.8744L23.3749 22.4602L17.7082 16.7935L16.294 18.2078Z",
  fill: "#4290F3"
})));

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.199dc905.svg";
export { ForwardRef as ReactComponent };